var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { 
// System User Info
setUserDataRedux, } from 'reducers/Login/action';
import Axios from 'axios';
import { Hidden, IconButton, useScrollTrigger, Drawer, List, SwipeableDrawer, withStyles, Fab, Avatar, } from '@material-ui/core';
import DateEnum from 'component/material/DatePicker/enum';
import { dAxios, snackBarRsp, daFormatTrans } from 'consts';
import { APP_PATH, loginIntra, HOST, loginInvoice, CUSTOMER } from 'config';
import logoIcon from 'asset/inc/img/global/logoIcon.png';
import logo from 'asset/inc/img/global/logo.png';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import Carousel from 'component/components/Carousel';
import styled from 'styled-components';
import dateLine from 'asset/inc/img/global/date-line.gif';
import ServiceList from 'view/Login/ServiceList';
import IconMoon from 'component/IconMoon/IconMoon';
import Slide from '@material-ui/core/Slide';
import { useSnackbar } from 'notistack';
import { ImgBase64 } from 'component/material/Image';
import { setLoadingRedux, } from 'reducers/sharedata/action';
import LoginInput from './LoginInput';
import { getAnnouncementsRedux } from 'reducers/sharedata/selector';
import { getToken } from 'main_api';
import qs from 'querystring';
import { getUserInfoRedux } from 'reducers/Login/selector';
import Grid from '@material-ui/core/Grid';
import { ButtonBar } from 'component/material/ButtonContained/ButtonBar';
import { ButtonContain } from 'component/material/ButtonContained/Button';
import PopDialog from 'component/LHH/PopDialog/PopDialog';
import { termsHtml } from './constants/terms';
var Style = require('./login_style.module.css');
var mainStyle = require('main_style.module.css');
// styled component---------------------------------------------
var LoginHeader = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  z-index: 2;\n  height: 80px;\n  min-width: 80%;\n  margin: 0;\n  padding: 0 12px;\n  background-color: #072c82;\n  display: flex;\n  justify-content: center;\n"], ["\n  z-index: 2;\n  height: 80px;\n  min-width: 80%;\n  margin: 0;\n  padding: 0 12px;\n  background-color: #072c82;\n  display: flex;\n  justify-content: center;\n"])));
var StyleLogo = styled.a(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: #fff;\n  text-decoration: none;\n  background: url(", ") no-repeat;\n  background-size: 60px;\n  background-position: left;\n  display: inline-block;\n  text-align: left;\n  padding-left: 65px;\n  display: inline-flex;\n  flex-direction: column;\n  justify-content: center;\n  div {\n    font-size: 2em;\n    margin: 2px 0;\n    line-height: 28px;\n    letter-spacing: 2px;\n    white-space: nowrap;\n  }\n  small {\n    color: #79bfff;\n    display: block;\n    white-space: nowrap;\n  }\n  @media screen and (max-width: 800px) {\n    background-size: 50px;\n    padding-left: 55px;\n    font-size: 0.8em;\n  }\n"], ["\n  color: #fff;\n  text-decoration: none;\n  background: url(", ") no-repeat;\n  background-size: 60px;\n  background-position: left;\n  display: inline-block;\n  text-align: left;\n  padding-left: 65px;\n  display: inline-flex;\n  flex-direction: column;\n  justify-content: center;\n  div {\n    font-size: 2em;\n    margin: 2px 0;\n    line-height: 28px;\n    letter-spacing: 2px;\n    white-space: nowrap;\n  }\n  small {\n    color: #79bfff;\n    display: block;\n    white-space: nowrap;\n  }\n  @media screen and (max-width: 800px) {\n    background-size: 50px;\n    padding-left: 55px;\n    font-size: 0.8em;\n  }\n"])), logoIcon);
var MainMenu = styled.ul(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: inline-block;\n  list-style-type: none;\n  margin: 0px;\n  margin-left: 60px;\n  text-align: center;\n  padding-left: 0;\n  white-space: nowrap;\n  li {\n    display: inline-block;\n    position: relative;\n    border-top: 3px solid transparent;\n    a {\n      display: block;\n      color: #fff;\n      font-size: 2em;\n      line-height: 70px;\n      margin: 0 13px;\n      border: 3px dotted transparent;\n      text-decoration: none;\n      :hover {\n        text-decoration: none;\n        color: #ffba02;\n        border-bottom: 3px solid #ffba02;\n      }\n    }\n  }\n  @media screen and (max-width: 800px) {\n    margin-left: 30px;\n    li {\n      a {\n        font-size: 1.5em;\n      }\n    }\n  }\n  @media screen and (max-width: 700px) {\n    margin-left: 15px;\n    li {\n      a {\n        margin: 0 8px;\n      }\n    }\n  }\n"], ["\n  display: inline-block;\n  list-style-type: none;\n  margin: 0px;\n  margin-left: 60px;\n  text-align: center;\n  padding-left: 0;\n  white-space: nowrap;\n  li {\n    display: inline-block;\n    position: relative;\n    border-top: 3px solid transparent;\n    a {\n      display: block;\n      color: #fff;\n      font-size: 2em;\n      line-height: 70px;\n      margin: 0 13px;\n      border: 3px dotted transparent;\n      text-decoration: none;\n      :hover {\n        text-decoration: none;\n        color: #ffba02;\n        border-bottom: 3px solid #ffba02;\n      }\n    }\n  }\n  @media screen and (max-width: 800px) {\n    margin-left: 30px;\n    li {\n      a {\n        font-size: 1.5em;\n      }\n    }\n  }\n  @media screen and (max-width: 700px) {\n    margin-left: 15px;\n    li {\n      a {\n        margin: 0 8px;\n      }\n    }\n  }\n"])));
var StyleLogin = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: absolute;\n  right: 10%;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 1.2em;\n  z-index: 100;\n  @media screen and (max-width: 600px) {\n    right: 50%;\n    transform: translate(50%, -50%);\n  }\n"], ["\n  position: absolute;\n  right: 10%;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 1.2em;\n  z-index: 100;\n  @media screen and (max-width: 600px) {\n    right: 50%;\n    transform: translate(50%, -50%);\n  }\n"])));
var StyleLoginM = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  position: absolute;\n  right: 50%;\n  top: 50%;\n  font-size: 1.2em;\n  transform: translate(50%, -50%);\n  z-index: 100;\n"], ["\n  position: absolute;\n  right: 50%;\n  top: 50%;\n  font-size: 1.2em;\n  transform: translate(50%, -50%);\n  z-index: 100;\n"])));
var DateHr = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  color: #999;\n  margin-bottom: 10px;\n  background: url(", ") center no-repeat;\n"], ["\n  color: #999;\n  margin-bottom: 10px;\n  background: url(", ") center no-repeat;\n"])), dateLine);
var TitleIcon = styled(IconMoon)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  opacity: 0.6;\n  color: #afafaf;\n  width: 45px;\n"], ["\n  opacity: 0.6;\n  color: #afafaf;\n  width: 45px;\n"])));
var DrawerLists = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  z-index: 2;\n  background-color: #072c82;\n  text-align: center;\n"], ["\n  z-index: 2;\n  background-color: #072c82;\n  text-align: center;\n"])));
var StyleList = withStyles({
    root: {
        borderTop: '1px solid rgba(255,255,255,.1)',
        fontSize: '1.5em',
        lineHeight: '2em',
        color: '#fff',
    },
})(List);
// function component---------------------------------------------
var ScrollTrigger = function (props) {
    var threshold = props.threshold, children = props.children;
    return (React.createElement(Slide, { direction: "up", timeout: 1000, in: threshold
            ? useScrollTrigger({ disableHysteresis: true, threshold: threshold })
            : true },
        React.createElement("div", null, children)));
};
var News = function (props) {
    var validSDate = props.validSDate, context = props.context;
    return (React.createElement("div", { style: {
            maxWidth: '80%',
            fontSize: '1.5em',
            textAlign: 'center',
            margin: 'auto',
        } },
        React.createElement(DateHr, null,
            React.createElement("span", { style: { backgroundColor: 'white', padding: '0 10px' } }, validSDate)),
        React.createElement("p", { dangerouslySetInnerHTML: { __html: context } })));
};
var NewsSection = function (props) {
    var announcements = useSelector(getAnnouncementsRedux);
    return (React.createElement(ScrollTrigger, null,
        React.createElement(Grid, { container: true, spacing: 2, direction: "row-reverse" },
            React.createElement(Grid, { item: true, md: 12, lg: 8 },
                React.createElement("div", { style: {
                        fontSize: '3em',
                        textAlign: 'center',
                        margin: '30px 0 20px',
                        display: 'flex',
                    } },
                    React.createElement(TitleIcon, { icon: "speaker" }),
                    "\u6700\u65B0\u6D88\u606F"),
                React.createElement("div", null,
                    React.createElement("h1", null,
                        "1.EZWay \u9810\u8A08",
                        React.createElement("span", { style: { color: 'red' } }, "115\u5E743\u670815\u65E5 12:00-18:00"),
                        " \u9032\u884C\u505C\u6A5F\u7DAD\u8B77\u4F5C\u696D\uFF0C\u9020\u6210\u4E0D\u4FBF\u656C\u8ACB\u898B\u8AD2\u3002"),
                    React.createElement("h1", null,
                        "2.\u70BA\u914D\u5408\u6D77\u95DC\u5BE6\u540D\u8A8D\u8B49\u670D\u52D9\u8ABF\u6574\uFF0C\u81EA ",
                        React.createElement("span", { style: { color: 'red' } }, "114\u5E748\u670826\u65E5"),
                        "\u8D77\uFF0C\u96FB\u5B50\u5546\u52D9\u901A\u95DC\u5E73\u53F0\u4E2D\u6587\u59D3\u540D\u6BD4\u5C0D\u67E5\u8A62\u529F\u80FD\uFF0C\u50C5\u63D0\u4F9B\u4E0A\u50B3\uFF08\u67E5\u8A62\uFF09\u59D3\u540D\u8207\u624B\u6A5F\u865F\u78BC\u9032\u884C\u67E5\u8A62\uFF0C\u5206\u63D0\u55AE\u865F\u6B04\u4F4D\u70BA\u5FC5\u586B\u6B04\u4F4D\u3002\u63D0\u9192\u60A8\u52D9\u5FC5\u7559\u610F\u6B64\u8B8A\u66F4\uFF0C\u4EE5\u78BA\u4FDD\u670D\u52D9\u80FD\u6B63\u5E38\u4F7F\u7528\u3002"),
                    React.createElement("h1", null,
                        "3.\u672C\u5E73\u53F0\u81EA",
                        React.createElement("span", { style: { color: 'red' } }, "113\u5E7410\u67081\u65E5"),
                        "\u8D77\uFF0C\u5831\u95DC\u696D\u8005\u767B\u5165\u67E5\u8A62\u9808\u900F\u904E\u56FA\u5B9A\u5F0FIP\u767B\u5165\u64CD\u4F5C\uFF0C\u5982\u4F7F\u7528\u6D6E\u52D5\u5F0FIP\u767B\u5165 \uFF0C\u5C07\u5F71\u97FF\u5831\u95DC\u696D\u8005\u7121\u6CD5\u4F7F\u7528\u672C\u5E73\u53F0\u67E5\u8A62\u529F\u80FD\uFF0C\u8ACB\u76E1\u901F\u586B\u5BEB\u9644\u4EF6\u7533\u8ACB\u8868\u5411\u672C\u516C\u53F8\u63D0\u51FA\u56FA\u5B9A\u5F0FIP\u9023\u7DDA\u7533\u8ACB\u3002"),
                    React.createElement("h1", null,
                        "4.\u914D\u5408\u8CA1\u653F\u90E8\u95DC\u52D9\u7F72\u653F\u7B56\u4E26\u63D0\u5347\u670D\u52D9\u5B89\u5168\u6027\uFF0CEZWay APP\u81EA",
                        React.createElement("span", { style: { color: 'red' } }, "6\u670820\u65E5"),
                        "\u8D77\uFF0C\u7981\u6B62\u5883\u5916IP\u9023\u7DDA\u4F7F\u7528EZWay\u8FA6\u7406\u5BE6\u540D\u8A8D\u8B49\u8A3B\u518A\u53CA\u5BE6\u540D\u59D4\u4EFB\u4F5C\u696D\uFF0C\u8ACB\u60A8\u6539\u4EE5\u5883\u5167\u7DB2\u8DEF\u9032\u884C\u9023\u7DDA\u3002\u9020\u6210\u4E0D\u4FBF\uFF0C\u656C\u8ACB\u898B\u8AD2\u3002"))),
            React.createElement(Grid, { item: true, md: 12, lg: 4, direction: "row-reverse" },
                React.createElement("img", { alt: "EPA", src: "/image/EPA3.jpg" }))),
        React.createElement(Carousel, { autoplay: true, autoplaySpeed: 5000, sliderContent: announcements === null || announcements === void 0 ? void 0 : announcements.map(function (obj) { return (React.createElement(News, __assign({}, obj))); }) })));
};
var ServiceSection = function (props) {
    var _a = useState([]), serviceArray = _a[0], setServiceArray = _a[1];
    var getService = function () {
        var tempArray = [
            {
                icon: React.createElement(IconMoon, { icon: "tax" }),
                title: '保稅稽核系統',
                onClick: function (e) { return console.log(e); },
            },
            {
                icon: React.createElement(IconMoon, { icon: "bill" }),
                title: '自貿港帳冊稽銷系統',
                onClick: function (e) { return console.log(e); },
            },
            {
                icon: React.createElement(IconMoon, { icon: "container" }),
                title: '業界貨櫃資訊平臺',
                onClick: function (e) { return console.log(e); },
            },
            {
                icon: React.createElement(IconMoon, { icon: "fly2" }),
                title: '空運業界自動化服務系統',
                onClick: function (e) { return console.log(e); },
            },
            {
                icon: React.createElement(IconMoon, { icon: "port" }),
                title: '自貿港服務網',
                onClick: function (e) { return console.log(e); },
            },
            {
                icon: React.createElement(IconMoon, { icon: "ttax" }),
                title: '稅費系統',
                onClick: function (e) { return console.log(e); },
            },
            {
                icon: React.createElement(IconMoon, { icon: "ship-tax" }),
                title: '美國海關ISF系統',
                onClick: function (e) { return console.log(e); },
            },
        ];
        setServiceArray(tempArray);
    };
    useEffect(function () { return getService(); }, []);
    return (React.createElement(ScrollTrigger, { threshold: 250 },
        React.createElement(ServiceList, { serviceArray: serviceArray })));
};
var Login = function (props) {
    var enqueueSnackbar = useSnackbar().enqueueSnackbar;
    var dispatch = useDispatch();
    var history = props.history;
    var pathnameArray = history.location.pathname.split('/');
    var loginUrl_now = pathnameArray.pop();
    var _a = useState(false), menuShow = _a[0], setMenuShow = _a[1];
    var _b = useState(loginUrl_now), loginUrl = _b[0], setLoginUrl = _b[1];
    var _c = useState([]), AdArray = _c[0], setAdArray = _c[1];
    var userType = useSelector(getUserInfoRedux).userType;
    var search = history.location.search;
    var result = qs.parse(search.replace(/^\?/, ''));
    useEffect(function () {
        var flag = window.sessionStorage.getItem("showExpiredMsg");
        if (flag === "true") {
            enqueueSnackbar("密碼已過期，請變更密碼。", { variant: "warning" });
            // window.sessionStorage.removeItem("showExpiredMsg"); // 用完就清掉
        }
    }, [enqueueSnackbar]);
    /**
        //--密碼強制修改--/
    interface IModifyPwdDlg {
      onClose(): unknown;
      NeedOrigPwd?: boolean;
      _show: [boolean, Dispatch<SetStateAction<boolean>>];
      onCancel?: () => void; //
    }
        const ModifyPwdDlg = (props: IModifyPwdDlg): JSX.Element => {
          const dispatch = useDispatch();
          const { enqueueSnackbar } = useSnackbar();
        
          const {
            NeedOrigPwd = false,
            _show: [show, setShow],
          } = props;
        
          const dStoreData = {
            lang: 'TW',
        
            origPwd: '',
            newPwd: '',
            newPwd2: '',
          };
          const [storeData, setStoreData] = useState(dStoreData);
        
          const [newPwd2Err, setNewPwd2Err] = useState('');
          const [verifyError, setVerifyError] = useState(false);
        
          const UpdateData = (updateObj) =>
            setStoreData((prev) => ({ ...prev, ...updateObj }));
        
          const changePwdCheck = () => {
            setVerifyError(true);
        
            if (
              !storeData.origPwd ||
              !storeData.newPwd ||
              !storeData.newPwd2 ||
              storeData.newPwd !== storeData.newPwd2 ||
              storeData.origPwd.length < 5 ||
              storeData.newPwd.length < 5
            ) {
              return false;
            }
            return true;
          };
    
          const handlechangePwd = async (e) => {
            if (e && e.preventDefault) {
              e.preventDefault();
            }
        
            if (!changePwdCheck()) {
              return;
            }
        
            dispatch(setLoadingRedux(1));
    
              const payload = {
              ...storeData,
              // userId: loginData.userId,
              // userType: loginData.userType,
            };
            const response = await dAxios(
              'post',
              `${HOST}v1/user/other/secret`,
              storeData,
              enqueueSnackbar,
            );
            dispatch(setLoadingRedux(-1));
            if (!snackBarRsp(enqueueSnackbar, response)) {
              return;
            }
            if (response?.data.status === 'Y') setShow((prev) => !prev);
          };
        
          const QueryConds: ImGrid[] = [
        
            {
              t: '*原密碼',
              child: (
                <InputEngNum
                  className={mainStyle.input}
                  type="password"
                  verifyBeforeChange={verifyError}
                  placeholder="請輸入原密碼"
                  inputProps={{ minLength: 5, maxLength: 30 }}
                  value={storeData.origPwd || ''}
                  name="origPwd"
                  onChange={inputChange(UpdateData)}
                />
              ),
            },
            {
              t: '*新密碼',
              child: (
                <InputEngNum
                  className={mainStyle.input}
                  type="password"
                  verifyBeforeChange={verifyError}
                  // placeholder="請輸入英數字，長度可接受8~30碼"
                  helperText={
                    <span style={{ color: 'red', fontSize: 15 }}>
                      <div>
                        密碼設定需符合下列5項規則 <br />
                        &nbsp;&nbsp; ．包含英文大寫。 <br />
                        &nbsp;&nbsp; ．包含英文小寫。 <br />
                        &nbsp;&nbsp; ．包含數字。 <br />
                        &nbsp;&nbsp; ．包含特殊符號【僅限＠＄！％＊？＃】 。 <br />
                        &nbsp;&nbsp; ．長度至少8~30碼字元 。
                      </div>
                    </span>
                  }
                  inputProps={{ minLength: 8, maxLength: 30 }}
                  value={storeData.newPwd || ''}
                  name="newPwd"
                  onChange={inputChange(UpdateData)}
                />
              ),
            },
            {
              t: '*再次輸入新密碼',
              child: (
                <InputEngNum
                  className={mainStyle.input}
                  type="password"
                  verifyBeforeChange={verifyError}
                  error={newPwd2Err.length > 0}
                  helperText={newPwd2Err}
                  placeholder="請再次輸入新密碼"
                  inputProps={{ minLength: 5, maxLength: 30 }}
                  value={storeData.newPwd2 || ''}
                  name="newPwd2"
                  onChange={(e) => {
                    if (storeData.newPwd !== e.target.value)
                      setNewPwd2Err('請再次輸入密碼。');
                    else setNewPwd2Err('');
                    inputChange(UpdateData)(e);
                  }}
                />
              ),
            },
          ];
        
          const DlgConfig: PopDialogProps = {
            show,
            escExit: true,
            width: '30vw',
            title: '修改密碼',
            handleExit: () => setShow((prev) => !prev),
            children: (
              <form onInvalid={() => setVerifyError(true)} onSubmit={handlechangePwd}>
                <MasterGrids mGrids={QueryConds} md={[4, 8]} />
                <ButtonBar>
                  <ButtonContain
                    variant="outlined"
                    onClick={() => {
                      setShow((prev) => !prev);
                      props.onClose?.();
                    }}
                  >
                    取消
                  </ButtonContain>
                  <ButtonContain type="submit">儲存</ButtonContain>
                </ButtonBar>
              </form>
            ),
          };
        
          return <PopDialog {...DlgConfig} />;
        };
    */
    var _d = useState(null), savedLoginData = _d[0], setSavedLoginData = _d[1];
    var handleLogin = function (loginData) { return function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!loginData) {
                        enqueueSnackbar('登入資料缺失');
                        return [2 /*return*/];
                    }
                    if (e !== undefined) {
                        e.preventDefault();
                    }
                    if ('login' === loginUrl && loginData.userType === CUSTOMER && loginData.personCheck !== 'Y') {
                        enqueueSnackbar('請確認個資宣告內容。');
                        return [2 /*return*/];
                    }
                    if ('inv-login' === loginUrl) {
                        loginData.eid = history.location.search.split('=')[1];
                    }
                    if (!!window.sessionStorage.jwt) return [3 /*break*/, 2];
                    return [4 /*yield*/, getToken(enqueueSnackbar)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    dispatch(setLoadingRedux(1));
                    return [4 /*yield*/, chooseAPI(loginData, loginUrl)];
                case 3:
                    response = _a.sent();
                    dispatch(setLoadingRedux(-1));
                    if (!snackBarRsp(enqueueSnackbar, response, false)) {
                        return [2 /*return*/];
                    }
                    if ((response === null || response === void 0 ? void 0 : response.data.status) === 'P') {
                        setModifyPwdShow(true);
                        return [2 /*return*/];
                    }
                    if ((response === null || response === void 0 ? void 0 : response.data.status) === 'W') {
                        setCheckChangePwdShow({ show: true, msg: (response === null || response === void 0 ? void 0 : response.data.msg) || '您的密碼即將過期，是否現在變更？' });
                        setPwdExpireResp(response);
                        return [2 /*return*/];
                    }
                    if ('inv-login' === loginUrl && (response === null || response === void 0 ? void 0 : response.data.status) === 'Y') {
                        window.open(response.data.data.url);
                    }
                    if ((response === null || response === void 0 ? void 0 : response.data.status) === 'Y') {
                        window.sessionStorage.setItem('jwt', "Bearer " + (response === null || response === void 0 ? void 0 : response.data.data.token));
                        Axios.defaults.headers.Authorization = "Bearer " + (response === null || response === void 0 ? void 0 : response.data.data.token);
                        // actions.setJwtData("Bearer " + response?.data.data.token.token));
                        window.sessionStorage.setItem('userId', response === null || response === void 0 ? void 0 : response.data.data.userId);
                        window.sessionStorage.setItem('loginTime', daFormatTrans(new Date(), DateEnum.daTiFormatP));
                        // window.sessionStorage.setItem("username", decodeURI(response.headers.username));
                        // const isIntra =
                        //   props.history.location.pathname.toLowerCase().indexOf('intra') > -1;
                        // window.sessionStorage.setItem(
                        //   'loginPage',
                        //   isIntra ? '/login_intra' : '/login',
                        // );
                        dispatch(setUserDataRedux({ userId: response.data.data.userId, userName: '' }));
                        if (loginUrl === 'inv-login') {
                            return [2 /*return*/];
                        }
                        history.push(APP_PATH);
                    }
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    dispatch(setLoadingRedux(-1));
                    enqueueSnackbar('系統暫無回應請稍後再試或與管理人員聯絡');
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); }; };
    var chooseAPI = function (loginData, loginUrl) {
        if (loginUrl === 'inv-login') {
            return dAxios('POST', HOST + "v1/vendor/qry-carrierid", loginData, enqueueSnackbar);
        }
        return dAxios('POST', HOST + "wlogin", loginData, enqueueSnackbar);
    };
    var getAds = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dAxios('GET', HOST + "v1/system/ads", {
                        type: 'W',
                        action: 'B-HOME',
                        lang: 'TW',
                        adsLang: 'TW',
                    }, enqueueSnackbar)];
                case 1:
                    response = _a.sent();
                    if (!snackBarRsp(enqueueSnackbar, response, true)) {
                        return [2 /*return*/];
                    }
                    setAdArray((response === null || response === void 0 ? void 0 : response.data.data) || []);
                    return [2 /*return*/];
            }
        });
    }); };
    var getCaptcha = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, result_1, message;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dAxios("get", HOST + "v1/system/verfiryCode", {}, enqueueSnackbar)];
                case 1:
                    response = _a.sent();
                    if (response) {
                        result_1 = response.data.status;
                        if (result_1 === "Y" && response && response.data.data) {
                            // const base64Img = {...response.data.data};
                            // const code = response?.data.code;
                            // setVerifyCode(code)
                            // setVerifyImg("data:image/png;base64, " + base64Img.image);
                        }
                        else if (result_1 === "N") {
                            message = response.data.msg;
                            console.log(message);
                            enqueueSnackbar(message);
                        }
                    }
                    ;
                    return [2 /*return*/];
            }
        });
    }); };
    var init = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getToken(enqueueSnackbar)];
                case 1:
                    _a.sent();
                    getAds();
                    getCaptcha();
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        init();
        // if (window.innerWidth < 1024) {
        //   alert("本系統最低解析度為 1024 x 768 以上，建議調整解析度以利功能操作。");
        // }
    }, []);
    var LoginHeaderM = function () { return (React.createElement(React.Fragment, null,
        React.createElement("a", { href: loginUrl, title: "\u96FB\u5B50\u5546\u52D9\u901A\u95DC\u5E73\u53F0" },
            React.createElement("img", { width: 200, src: logo, alt: "" })),
        React.createElement("div", { style: { display: 'inline' } },
            React.createElement(IconButton, { onClick: function () { return setMenuShow(!menuShow); }, style: { paddingRight: '0px' } }, menuShow ? (React.createElement(CloseIcon, { fontSize: "large", style: { color: 'white' } })) : (React.createElement(MenuIcon, { fontSize: "large", style: { color: 'white' } })))))); };
    var _e = useState(false), modifyPwdShow = _e[0], setModifyPwdShow = _e[1];
    var _f = useState({ show: false, msg: '' }), checkChangePwdShow = _f[0], setCheckChangePwdShow = _f[1];
    var _g = useState(null), pwdExpireResp = _g[0], setPwdExpireResp = _g[1];
    var _h = useState({ userId: '', userType: '' }), storeData = _h[0], setStoreData = _h[1];
    var _j = useState(false), drawerOpen = _j[0], setDrawerOpen = _j[1];
    var _k = useState(false), termsOpen = _k[0], setTermsOpen = _k[1];
    var TermsDlg = function (props) {
        var show = props._show[0], onClose = props.onClose;
        var DlgConfig = {
            show: show,
            escExit: true,
            width: '70vw',
            title: '服務條款',
            handleExit: onClose,
            children: (React.createElement("div", null,
                React.createElement("div", { style: { fontSize: '1em', maxHeight: '65vh', overflowY: 'auto', lineHeight: 1.6 } },
                    React.createElement("div", { dangerouslySetInnerHTML: { __html: termsHtml } })),
                React.createElement(ButtonBar, null,
                    React.createElement(ButtonContain, { onClick: onClose }, "\u78BA\u8A8D")))),
        };
        return React.createElement(PopDialog, __assign({}, DlgConfig));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(TermsDlg, { _show: [termsOpen, setTermsOpen], onClose: function () { return setTermsOpen(false); } }),
        React.createElement("div", null,
            React.createElement("div", { className: "header" },
                React.createElement(Hidden, { smDown: true },
                    React.createElement(LoginHeader, null,
                        React.createElement(StyleLogo, { href: loginUrl, title: "\u96FB\u5B50\u5546\u52D9\u901A\u95DC\u5E73\u53F0" },
                            React.createElement("div", null, "\u96FB\u5B50\u5546\u52D9\u901A\u95DC\u5E73\u53F0"),
                            React.createElement("small", null, "E-commerce customs clearance platform")),
                        React.createElement(MainMenu, null,
                            React.createElement("li", null,
                                React.createElement("a", { title: "\u6700\u65B0\u6D88\u606F" }, "\u6700\u65B0\u6D88\u606F")),
                            React.createElement("li", null,
                                React.createElement("a", { title: "\u806F\u7D61\u6211\u5011" }, "\u806F\u7D61\u6211\u5011")),
                            React.createElement("li", null,
                                React.createElement("a", { href: "#", title: "\u670D\u52D9\u689D\u6B3E", onClick: function (e) { e.preventDefault(); setTermsOpen(true); } }, "\u670D\u52D9\u689D\u6B3E")),
                            React.createElement("li", null,
                                React.createElement("a", { style: { color: '#ffff33', fontSize: '32px', fontWeight: 'bold' }, title: "" }, "\u6B64\u70BA\u6E2C\u8A66\u74B0\u5883\uFF0C\u8CC7\u6599\u50C5\u4F9B\u6A21\u64EC\u53C3\u8003"))))),
                React.createElement(Hidden, { mdUp: true },
                    React.createElement(LoginHeaderM, null),
                    React.createElement(Drawer, { open: menuShow },
                        React.createElement(SwipeableDrawer, { anchor: "top", open: menuShow, onClose: function () { return setMenuShow(false); }, onOpen: function () { return setMenuShow(true); } },
                            React.createElement(DrawerLists, null,
                                React.createElement("div", { className: "header" },
                                    React.createElement(LoginHeaderM, null)),
                                React.createElement(StyleList, null, "\u6700\u65B0\u6D88\u606F"),
                                React.createElement(StyleList, null, "\u806F\u7D61\u6211\u5011"),
                                React.createElement(StyleList, { onClick: function () { return setTermsOpen(true); } }, "\u670D\u52D9\u689D\u6B3E")))))),
            React.createElement("div", { style: {
                    position: 'relative',
                    minHeight: '300px',
                    backgroundColor: 'rgb(247, 247, 247)',
                } },
                React.createElement(Carousel, { arrowsRWD: true, autoplay: true, fade: true, dotsIn: true, sliderContent: AdArray.map(function (obj, idx) { return (React.createElement(ImgBase64, { src: obj.file, download: false, style: {
                            maxWidth: 'fit-content',
                            height: '400px',
                        } })); }) }),
                React.createElement(StyleLogin, null,
                    React.createElement(LoginInput, { history: history, intra: loginUrl === loginIntra, intra_invoice: loginUrl === loginInvoice, handleLogin: handleLogin, modifyPwdShow: modifyPwdShow, setModifyPwdShow: setModifyPwdShow, checkChangePwdShow: checkChangePwdShow, setCheckChangePwdShow: setCheckChangePwdShow, storeData: storeData, setStoreData: setStoreData, pwdExpireResp: pwdExpireResp, setPwdExpireResp: setPwdExpireResp }))),
            React.createElement(NewsSection, null),
            React.createElement(ServiceSection, null),
            React.createElement("a", { href: "https://chatbot.tradevan.com.tw/lc/#/LTNV2HxG7R73SmMKQFLOeCASVAE", target: "_blank" },
                React.createElement(Fab, { color: "primary", style: { position: 'fixed', bottom: 20, right: 20 } },
                    React.createElement(Avatar, { variant: "rounded", src: "/image/Customer Service.png" }))))));
};
export default Login;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
